(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lekur-hero-video')) {
    customElements.define('lekur-hero-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const video = this.querySelector('video');
        if (!video) return;
        this.video = video;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const cover = () => {
          this.removeAttribute('data-playing');
          if (this.frame != null) {
            video.cancelVideoFrameCallback(this.frame);
            this.frame = null;
          }
        };
        const reveal = () => {
          if (video.paused || video.ended || video.seeking || video.readyState < 3 || document.hidden) return;
          if (this.hasAttribute('data-playing') || this.frame != null) return;
          if (typeof video.requestVideoFrameCallback === 'function') {
            this.frame = video.requestVideoFrameCallback(() => {
              this.frame = null;
              if (!video.paused && !video.ended && !video.seeking && video.readyState >= 3 && !document.hidden) {
                this.setAttribute('data-playing', '');
              }
            });
          } else {
            this.setAttribute('data-playing', '');
          }
        };
        ['playing', 'timeupdate'].forEach(event => video.addEventListener(event, reveal, options));
        ['pause', 'waiting', 'seeking', 'emptied', 'error', 'ended'].forEach(event => video.addEventListener(event, cover, options));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) cover();
          else reveal();
        }, options);
        cover();
        reveal();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.frame != null) {
          this.video.cancelVideoFrameCallback(this.frame);
          this.frame = null;
        }
        this.removeAttribute('data-playing');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
